module.exports = __webpack_public_path__ + "media/close-black.40d96c15.svg";